// Turn engine tables into grid cells (core / विकल्प split, plus the review state of the core form).

import type { GridCell } from '@/prakrit/components/grammar/grammar-grid'
import type {
    Case,
    Cell,
    Num,
    Person,
    PersonTable
} from '@/prakrit/lib/grammar/types'

import { CASES, NUMBERS, PERSONS } from '@/prakrit/lib/grammar/types'

export type StatusLookup = (key: string) => string | undefined

const toCell = (cell: Cell | undefined, keyOf: (form: string) => string, status?: StatusLookup): GridCell => {
    const list = cell ?? []
    const core = list.filter(f => f.status === 'core').map(f => f.form)
    const alt = list.filter(f => f.status === 'alt').map(f => f.form)
    const reviews = core.map(f => status?.(keyOf(f)) ?? 'needs_review')
    const review = reviews.every(r => r === 'published') ? 'published'
        : reviews.every(r => r === 'verified' || r === 'published') ? 'verified'
            : reviews.find(r => r !== 'verified' && r !== 'published') ?? 'needs_review'

    return { core, alt, review }
}

export const verbCells = (
    root: string,
    tense: string,
    grid: PersonTable | undefined,
    status?: StatusLookup
): Record<Person, Record<Num, GridCell>> => {
    const out = {} as Record<Person, Record<Num, GridCell>>

    for (const p of PERSONS) {
        out[p] = {} as Record<Num, GridCell>

        for (const n of NUMBERS) {
            out[p][n] = toCell(grid?.[p]?.[n], f => `vf|${root}|${tense}|${p}|${n}|${f}`, status)
        }
    }

    return out
}

export const caseCells = (
    prefix: 'nf' | 'pf',
    lemma: string,
    table: Partial<Record<Case, Record<Num, Cell>>>,
    status?: StatusLookup
): Partial<Record<Case, Record<Num, GridCell>>> => {
    const out: Partial<Record<Case, Record<Num, GridCell>>> = {}

    for (const c of CASES) {
        const row = table[c]

        if (!row) continue

        out[c] = {
            eka: toCell(row.eka, f => `${prefix}|${lemma}|${c}|eka|${f}`, status),
            bahu: toCell(row.bahu, f => `${prefix}|${lemma}|${c}|bahu|${f}`, status)
        }
    }

    return out
}
